(function () {
  var styleId = "ask-product-zoom-style";
  var lensId = "ask-product-zoom-lens";
  var zoomScale = 2.8;
  var lensSize = 220;

  function injectStyles() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      @media (min-width: 768px) {
        .theme-gallery--zoom-enabled .theme-img[data-full-size] {
          cursor: zoom-in;
        }

        #ask-product-zoom-lens {
          position: fixed;
          width: ${lensSize}px;
          height: ${lensSize}px;
          border: 2px solid rgba(255, 255, 255, 0.95);
          border-radius: 50%;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);
          pointer-events: none;
          opacity: 0;
          transform: translate(-50%, -50%);
          background-repeat: no-repeat;
          background-color: #fff;
          z-index: 9999;
          transition: opacity 0.12s ease;
        }

        #ask-product-zoom-lens.is-visible {
          opacity: 1;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getLens() {
    var lens = document.getElementById(lensId);

    if (!lens) {
      lens = document.createElement("div");
      lens.id = lensId;
      document.body.appendChild(lens);
    }

    return lens;
  }

  function initProductZoom() {
    if (!window.matchMedia("(min-width: 768px)").matches) return;

    var lens = getLens();

    var slides = document.querySelectorAll(
      ".theme-gallery--zoom-enabled .theme-img[data-full-size]"
    );

    slides.forEach(function (slide) {
      if (slide.dataset.askZoomInitialized === "true") return;

      var image = slide.querySelector("img");
      var zoomUrl = slide.getAttribute("data-full-size");

      if (!image || !zoomUrl) return;

      slide.dataset.askZoomInitialized = "true";

      function hideLens() {
        lens.classList.remove("is-visible");
      }

      function moveLens(event) {
        var rect = image.getBoundingClientRect();

        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;

        if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
          hideLens();
          return;
        }

        var zoomWidth = rect.width * zoomScale;
        var zoomHeight = rect.height * zoomScale;

        var bgX = lensSize / 2 - x * zoomScale;
        var bgY = lensSize / 2 - y * zoomScale;

        lens.style.left = event.clientX + "px";
        lens.style.top = event.clientY + "px";
        lens.style.backgroundImage = "url('" + zoomUrl + "')";
        lens.style.backgroundSize = zoomWidth + "px " + zoomHeight + "px";
        lens.style.backgroundPosition = bgX + "px " + bgY + "px";
        lens.classList.add("is-visible");
      }

      slide.addEventListener("mousemove", moveLens);
      slide.addEventListener("mouseenter", moveLens);
      slide.addEventListener("mouseleave", hideLens);
    });
  }

  function boot() {
    injectStyles();
    initProductZoom();
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();